import { render, staticRenderFns } from "./vendors_list.vue?vue&type=template&id=e33802be&scoped=true&"
import script from "./vendors_list.vue?vue&type=script&lang=js&"
export * from "./vendors_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33802be",
  null
  
)

/* custom blocks */
import block0 from "@/lang/table.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fvendors%2Fvendors_list.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "@/lang/actions.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fbuilds%2Ffabrika-klientov%2Fappearance%2Fwhite%2Fsrc%2Fcomponents%2Fvendors%2Fvendors_list.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports